import type { ProfileAudienceAndSharedResponse, ProfileAudienceShare } from 'pages/Customize/types';
import type { BasicSuccessResponse, HTTPFunctions, ProfileUsersToShareRequest, ProfileUsersToShareResponse } from '../types';
import type { NewProfileAudience, ProfileAudience } from 'pages/NewDocument/types';

const profiles = ({ get, post, put, del }: HTTPFunctions) => ({
  getProfiles: () => get<ProfileAudienceAndSharedResponse>('audience_profile/'),
  getProfileById: (id: number) => get<ProfileAudience>(`audience_profile/${id}`),
  addProfile: (profile: NewProfileAudience) => post<ProfileAudienceShare>('audience_profile/', {...profile}),
  updateProfile: (profile: ProfileAudience) => put<ProfileAudienceShare>(`audience_profile/${profile.id}`, {...profile}),
  delProfile: (id: number) => del<BasicSuccessResponse>(`audience_profile/${id}`),
  getProfileUsersToShare: (id: number) => get<ProfileUsersToShareResponse>(`audience_profile/share/${id}`),
  setProfileUsersToShare: (id: number, data: ProfileUsersToShareRequest) => put<BasicSuccessResponse>(`audience_profile/share/${id}`, data)
});

export default profiles;
